module.exports = __webpack_public_path__ + "static/media/Commercial-Construction.395ae395.jpg";